import styled, { css } from 'styled-components';
import Typography from '@nubank/nuds-web/components/Typography/Typography';
import { breakpointsMedia } from '@nubank/nuds-web/styles/breakpoints';

export const StyledTypography = styled(Typography)`
  ${breakpointsMedia({
    xs: css`
      text-align: left;
      width: 100%;
    `,
  })}
  ${breakpointsMedia({
    md: css`
      text-align: center;
      width: 100%;
    `,
  })}
  ${breakpointsMedia({
    lg: css`
      text-align: left;
      width: 100%;
    `,
  })}
`;
